import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Chat from '@/views/Chat.vue'
import MChat from '@/views/MChat.vue'

Vue.use(VueRouter)

// 检测是否为移动设备
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent) || window.innerWidth <= 768
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
    meta: { requiresAuth: true }
  },
  {
    path: '/mchat',
    name: 'MChat',
    component: MChat,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('auth_token')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next('/login')
    } else {
      // 设备检测：手机访问 /chat 时跳转到 /mchat，PC访问 /mchat 时跳转到 /chat
      if (to.path === '/chat' && isMobileDevice()) {
        next('/mchat')
      } else if (to.path === '/mchat' && !isMobileDevice()) {
        next('/chat')
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
